module.exports = __webpack_public_path__ + "static/media/ResourceOwnerPasswordCredentialsGrant.286c6ff7.png";